import hslToHex from 'hsl-to-hex'
import { mapListener, getTypeForNode } from 'Services/WeaverUtils'
import { GraphColors, TypeColors } from 'Model'

class ColorService
  constructor: ->
    @typeColorMap = {}
    @graphColorMap = {}

  init: ->
    try
      @typeColorMap = (await TypeColors.load()).map()
      @graphColorMap = (await GraphColors.load()).map()
    catch
      @typeColorMap = {}
      @graphColorMap = {}

    if _.isString(@typeColorMap)
      @typeColorMap = _.reduce(@typeColorMap.split('#!#'), (acc, val) ->
        [key, val] = val.split('#?#')
        { acc..., [key]: val }
      , {})
      (await TypeColors.load()).update(@typeColorMap)

    if _.isString(@graphColorMap)
      @graphColorMap = _.reduce(@graphColorMap.split('#!#'), (acc, val) ->
        [key, val] = val.split('#?#')
        { acc..., [key]: val }
      , {})
      (await GraphColors.load()).update(@graphColorMap)

    @typeColors = mapListener(@typeColorMap, _.debounce(=>
      (await TypeColors.load()).update(@typeColorMap)
    , 100))

    @graphColors = mapListener(@graphColorMap, _.debounce(=>
      (await GraphColors.load()).update(@graphColorMap)
    , 100))

  fixColors: ->
    hexTest = /^#([0-9A-F]{3}){1,2}$/i
    for key, value of @typeColors
      if not hexTest.test(value)
        @typeColors[key] = @getColor(_.values(@typeColorMap).length)

    for key, value of @graphColors
      if not hexTest.test(value)
        @graphColors[key] = @getColor(_.values(@graphColorMap).length)

  getColor: (colourCount) -> # will start repeating after 72 colours
    colourCount ?= _.values(@typeColorMap).length
    hue = 0
    while colourCount > 0
      hue = (hue + 95) % 360
      colourCount--
    hslToHex(hue, 50, 75)

  getColorForType: (type) ->
    @typeColors[type] ?= if type is undefined then "#EEEEEE" else @getColor(_.values(@typeColorMap).length)

  setColorForType: (type, color) ->
    @typeColorMap[type] = color

  getColorForNode: (node) ->
    @getColorForType(getTypeForNode(node))

  getColorForGraph: (graph) ->
    @graphColors[graph] ?= if graph is undefined then "#EEEEEE" else @getColor(_.values(@graphColorMap).length)

  setColorForGraph: (graph, color) ->
    @graphColorMap[graph] = color

export default new ColorService()

